// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"c322a1d5","66":"82fe480e","149":"df85d9b8","296":"141953f4","433":"b2c45c3f","600":"6e42bea9","725":"cdf786d0","748":"5e9a1e04","804":"4a66c8ce","932":"c1505bfb","990":"0a745dea"}[chunkId] + ".chunk.js";
};